<template>
  <div>
    <div class="card">
      <div class="card-header animated fadeInRightBig">
        <div class="card-title">
          Usuário
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-4">
            <label><span class="required">*</span> Nome:</label>
            <input
              id="name"
              v-model="user.name"
              type="text"
              class="form-control"
              name="name"
            >
          </div>
          <div class="col-md-4">
            <label for="email"><span class="required">*</span> Email</label>
            <input
              id="email"
              v-model="user.email"
              type="email"
              class="form-control"
              autocomplete="new-password"
              name="email"
            >
          </div>
          <div class="col-md-4">
            <label for="active_date"><span class="required">*</span> Ativo após:</label>
            <input
              id="active_date"
              v-model="user.active_date"
              type="date"
              class="form-control"
              name="active_date"
            >
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <label><span class="required">*</span> Senha</label>
            <input
              id="password"
              v-model="user.password"
              type="password"
              name="password"
              class="form-control"
              autocomplete="new-password"
            >
          </div>
          <div class="col-md-2">
            <label for="inputUser">
              <span class="required">*</span> Nível de acesso:
            </label>
            <select
              v-model="user.is_admin"
              class="form-control"
            >
              <option
                v-if="$store.state.user.is_admin === 1"
                :key="1"
                :value="1"
              >
                Administrador Geral
              </option>

              <option
                v-if="$store.state.user.is_admin !== 4"
                :key="2"
                :value="2"
              >
                Administrador Empresa
              </option>

              <option
                :key="3"
                :value="3"
              >
                Usuário Padrão
              </option>
              <option
                :key="4"
                :value="4"
              >
                Supervisor
              </option>
            </select>
          </div>

          <div class="col-md-2">
            <label> Acesso Rápido</label>
            <input
              v-model="user.quick_access"
              v-mask="'##############'"
              type="number"
              class="form-control"
            >
          </div>
          <div class="col-md-4">
            <label><span class="required">*</span> Permitir Ponto Remoto</label>
            <select
              v-model="user.remote_check"
              class="form-control"
            >
              <option value="0">
                Não
              </option>
              <option value="1">
                Sim
              </option>
            </select>
          </div>
        </div>
        <br>
        <hr class="m-t-md m-b-md">
        <div class="row">
          <div class="col-md-4">
            <label><span class="required">*</span> Departamento:</label>
            <select
              v-model="user.department_id"
              class="form-control"
            >
              <option
                v-for="department in departments"
                :key="department.id"
                :value="department.id"
              >
                {{ department.title }}
              </option>
            </select>
          </div>
          <div class="col-md-4">
            <label><span class="required">*</span> Cargo</label>
            <select
              v-model="user.role_id"
              class="form-control"
            >
              <option
                v-for="role in roles"
                :key="role.id"
                :value="role.id"
              >
                {{ role.title }}
              </option>
            </select>
          </div>
          <div class="col-md-4">
            <label><span class="required">*</span> Empresa:</label>
            <select
              v-model="user.company_id"
              class="form-control"
            >
              <option
                v-for="company in companies"
                :key="company.id"
                :value="company.id"
              >
                {{ company.company_name }}
              </option>
            </select>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-md-4">
            <label><span class="required">*</span> Alocações</label>
            <v-select
              v-model="alocationsSelected"
              :options="alocations"
              label="name"
              :reduce="item => item.id"
              multiple
              placeholder="Selecione as alocações"
            />
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-md-12">
            <label>Endereço</label>
            <AddressAutocomplete
              v-model="user.address"
              :google-api-key="googleApiKey"
              placeholder="Ex: Rua abc,12,Teste Bairro, Teste Cidade - Estado"
              input-ref="mainAddressInput"
              dropdown-ref="mainAddressDropdown"
              @select="onMainAddressSelect"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-2 mt-2">
            <label for="admission_date"><span class="required">*</span> Data de Admissão</label>
            <input
              id="admission_date"
              v-model="user.admission_date"
              type="date"
              class="form-control"
              name="admission_date"
            >
          </div>
          <div class="col-md-2 mt-2">
            <label for="demission_date">Data de Demissão</label>
            <input
              id="demission_date"
              v-model="user.demission_date"
              type="date"
              class="form-control"
              name="demission_date"
            >
          </div>
          <div class="col-md-4 mt-2">
            <label>Valor do Vale Transporte</label>
            <input
              id="transport_value"
              v-model="user.transport_value"
              v-money="money"
              type="text"
              class="form-control"
              name="transport_value"
            >
          </div>
          <div class="col-md-4 mt-2">
            <label>Jornadas</label>
            <v-select
              v-model="worktimesSelected"
              :options="worktimes"
              label="title"
              :reduce="item => item.id"
              multiple
            />
          </div>
          <div class="col-md-4 mt-2">
            <label>Requisitos</label>
            <v-select
              v-model="requirementsSelected"
              :options="uniqueRequirements"
              label="name"
              :reduce="item => item.id"
              multiple
              :selectable="option => !requirementsSelected.includes(option.id)"
              placeholder="Selecione os requisitos"
            />
          </div>
        </div>
        <div class="row">
        <div class="col-md-4">
          <label><span class="required">*</span> CPF</label>
          <div class="d-flex align-items-center">
            <input
                type="text"
                class="form-control"
                v-mask="'###.###.###-##'"
                v-model="user.cpf"
                name="cpf"
                id="cpf"
                placeholder="000.000.000-00"
                :disabled="!cpfEditable"
            />
            <button
                v-if="user.id"
                type="button"
                class="btn btn-link p-0 ml-2"
                title="Editar CPF"
                @click.prevent="requestCpfEdit"
            >
              <i class="fa fa-pencil-alt"></i>
            </button>
          </div>
        </div>
          <div class="col-md-4">
            <label>Carteira de trabalho:</label>
            <input
              id="ctps"
              v-model="user.ctps"
              v-mask="'######'"
              type="text"
              class="form-control"
              name="ctps"
              placeholder="000000"
            >
          </div>
          <div class="col-md-4">
            <label>PIS/PASEP</label>
            <input
              id="pis_pasep"
              v-model="user.pis_pasep"
              v-mask="'###.#####.##-#'"
              type="text"
              class="form-control"
              name="pis_pasep"
              placeholder="00.00000.00-0"
            >
          </div>
        </div>
        <hr class="m-t-md m-b-md">

        <div class="row">
          <div class="col-md-8">
            <label>Foto do Usuário</label>
            <input
              id="photo"
              type="file"
              name="photo"
            >
          </div>
          <div class="col-md-4 d-flex align-items-center">
            <div>
              <label class="d-block mb-1">Foto Verificada</label>
              <div class="d-flex align-items-center">
                <div
                  v-if="$store.state.user.is_admin === 1 || $store.state.user.is_admin === 2 || $store.state.user.is_admin === 4"
                  class="custom-control custom-switch mr-2"
                >
                  <input
                    id="user_photo_verified"
                    v-model="user.photo_verified"
                    type="checkbox"
                    class="custom-control-input"
                  >
                  <label
                    class="custom-control-label"
                    for="user_photo_verified"
                  >
                    <span v-if="user.photo_verified"><i class="fa fa-check text-success" /> Verificada</span>
                    <span v-else><i class="fa fa-times text-muted" /> Não Verificada</span>
                  </label>
                </div>
                <div v-else>
                  <span
                    v-if="user.photo_verified"
                    class="badge badge-success"
                  ><i
                    class="fa fa-check"
                  /> Verificada</span>
                  <span
                    v-else
                    class="badge badge-secondary"
                  >Não Verificada</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr>

        <div class="col-md-12">
          <h5>Cercas do Usuário (Endereços e Raio em metros)</h5>
          <div class="row mb-2 align-items-center">
            <div class="col-md-4">
              <label class="font-weight-bold"><span class="required">*</span> Cercas Habilitadas</label>
              <div class="d-flex align-items-center">
                <div
                  v-if="$store.state.user.is_admin === 1 || $store.state.user.is_admin === 2 || $store.state.user.is_admin === 4"
                  style="width:100%"
                >
                  <select
                    v-model="user.geofence_enabled"
                    class="form-control"
                  >
                    <option :value="true">
                      Sim
                    </option>
                    <option :value="false">
                      Não
                    </option>
                  </select>
                </div>
                <div v-else>
                  <span
                    v-if="user.geofence_enabled"
                    class="badge badge-success"
                  ><i class="fa fa-check" /> Habilitada</span>
                  <span
                    v-else
                    class="badge badge-secondary"
                  >Desabilitada</span>
                </div>
              </div>
              <small class="text-muted">Ative para cadastrar endereços de cerca geográfica.</small>
            </div>
          </div>
          <div
            v-for="(g, idx) in user.geofences"
            :key="idx"
            class="card p-2 mb-2"
          >
            <div class="row align-items-center">
              <div class="col-md-8">
                <label>Endereço:</label>
                <AddressAutocomplete
                  v-model="g.address"
                  :google-api-key="googleApiKey"
                  placeholder="Comece digitando um endereço..."
                  :input-ref="'geofenceAddressInput-' + idx"
                  :dropdown-ref="'geofenceAddressDropdown-' + idx"
                  @select="suggestion => onGeofenceAddressSelect(suggestion, idx)"
                />
                <div class="mt-2">
                  <button
                    type="button"
                    class="btn btn-link btn-sm p-0"
                    @click="openMapModal(idx)"
                  >
                    <i class="fas fa-map" /> Ver mapa
                  </button>
                </div>
              </div>
              <div class="col-md-3 d-flex align-items-center">
                <label class="mb-0 mr-2">Raio (em metros):</label>
                <input
                  v-model.number="g.radius"
                  type="number"
                  class="form-control"
                  min="10"
                  placeholder="Raio (m)"
                >
              </div>
              <div class="col-md-1 d-flex align-items-center justify-content-end">
                <button
                  class="btn btn-danger"
                  @click.prevent="user.geofences.splice(idx,1)"
                >
                  <i class="fa fa-trash" /></button>
              </div>
            </div>
          </div>

          <b-modal
            v-model="showMapModal"
            size="lg"
            hide-footer
            title="Selecionar Localização no Mapa"
            @shown="onMapShown"
            @hidden="onMapHidden"
          >
            <div style="height: 400px; width: 100%; position: relative;">
              <div
                v-if="loadingStates.map"
                class="d-flex justify-content-center align-items-center"
                style="position:absolute;top:0;left:0;width:100%;height:100%;background:rgba(255,255,255,0.7);z-index:10;"
              >
                <span><i class="fas fa-spinner fa-spin fa-2x" /> Carregando mapa...</span>
              </div>
              <div
                id="geofence-map"
                style="height: 100%; width: 100%;"
              />
            </div>
            <div
              v-if="mapGeofenceIdx !== null && user.geofences[mapGeofenceIdx]"
              class="mt-2"
            >
              <div class="row">
                <div class="col-md-4">
                  <label>Raio (em metros):</label>
                  <input
                    v-model.number="user.geofences[mapGeofenceIdx].radius"
                    type="number"
                    class="form-control"
                    min="10"
                  >
                </div>
              </div>
            </div>
          </b-modal>

          <b-modal
              v-model="showCpfConfirmModal"
              title="Confirmar alteração de CPF"
              ok-title="Sim, alterar"
              cancel-title="Cancelar"
              @ok="confirmCpfEdit"
          >
            <p>Tem certeza que deseja alterar o CPF deste usuário?</p>
          </b-modal>

          <div>
            <button
              class="btn btn-primary"
              @click.prevent="user.geofences.push({address:'', radius:100})"
            >+ Adicionar
              Endereço
            </button>
          </div>
        </div>

        <div class="block text-right mb-1">
          <router-link
            to="/users"
            class="btn btn-back"
          >
            <i class="fa fa-arrow-left" /> Voltar
          </router-link>
          <a
            class="btn btn-add ml-1"
            @click="save"
          >
            Salvar
            <i class="fa fa-save" />
          </a>
        </div>
        <div class="row">
          <div class="col-md-4">
            <p><span class="required">*</span> Campos Obrigatórios</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AddressAutocomplete from '@/components/AddressAutocomplete.vue'
import { mask } from 'vue-the-mask'
import { VMoney } from 'v-money'
import { isValidEmail, isValidCpf } from '@/utils/validators'
import { apiErrorMessage } from '@/utils/apiError'
import env from '../../config/env.js'

export default {
  components: { AddressAutocomplete },
  directives: { mask, money: VMoney },
  data() {
    return {
      filters: {
        address: '',
      },
      loadingStates: {
        geocoding: false,
        map: false,
      },
      showMapModal: false,
      showCpfConfirmModal: false,
      cpfEditable: true,
      map: null,
      mapMarker: null,
      mapGeofenceIdx: null,
      user: {
        name: '',
        email: '',
        password: '',
        department_id: '',
        role_id: '',
        admission_date: '',
        demission_date: '',
        cpf: '',
        ctps: '',
        pis_pasep: '',
        quick_access: null,
        remote_check: '0',
        company_id: '',
        alocation_id: '',
        alocation_ids: [],
        geofences: [],
        address: '',
        latitude: null,
        longitude: null,
        photo_verified: true,
        geofence_enabled: false,
      },
      alocationsSelected: [],
      worktimesSelected: [],
      requirementsSelected: [],
      worktimes: [],
      requirements: [],
      departments: [],
      companies: [],
      alocations: [],
      roles: [],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: true,
      },
      autocomplete: null,
      googleApiKey: env.VUE_APP_GOOGLE_MAPS_API_KEY,
      addressSuggestions: [],
      showAddressDropdown: false,
      selectedSuggestionIndex: -1,
      mainAddressSuggestions: [],
      showMainAddressDropdown: false,
      selectedMainSuggestionIndex: -1,
      searchTimeout: null,
      placesService: null,
      mapCircle: null,
      mainAddress: '',
      geofenceAddresses: [],
    }
  },
  computed: {
    uniqueRequirements() {
      const seen = new Set()
      return (this.requirements || []).filter(r => {
        if (!r || seen.has(r.id)) return false
        seen.add(r.id)
        return true
      })
    },
  },
  watch: {
    mapGeofenceIdx(val) {
      this.$nextTick(() => {
        if (
          this.mapCircle
            && this.user.geofences[val]
            && typeof this.user.geofences[val].radius !== 'undefined'
        ) {
          this.mapCircle.setRadius(Number(this.user.geofences[val].radius) || 100)
        }
      })
    },
    'user.geofences': {
      handler(val) {
        if (
          this.mapCircle
            && this.mapGeofenceIdx !== null
            && val[this.mapGeofenceIdx]
            && typeof val[this.mapGeofenceIdx].radius !== 'undefined'
        ) {
          this.mapCircle.setRadius(Number(val[this.mapGeofenceIdx].radius) || 100)
        }
      },
      deep: true,
    },
  },
  mounted() {
    const self = this
    self.initGooglePlaces()
    self.getDepartments()
    self.getRoles()

    const { id } = self.$route.params
    if (id) {
      self.getUser(id)
    }

    self.getDepartments()
    self.getAlocation()
    self.getRoles()
    self.getWorktimes()
    self.getCompany()
    self.getRequirements()
  },
  methods: {
    onMainAddressSelect(suggestion) {
      this.user.address = suggestion.description
    },
    onGeofenceAddressSelect(suggestion, idx) {
      this.user.geofences[idx].address = suggestion.description
    },
    initMapForGeofence(idx) {
      if (idx === null || idx === undefined) return
      if (!window.google?.maps) return

      const g = this.user.geofences[idx] || {}
      const lat = Number(g.latitude) || -23.55052
      const lng = Number(g.longitude) || -46.633308

      this.setMapAndMarker(lat, lng)
      this.loadingStates.map = false
    },

    setMapAndMarker(lat, lng) {
      const el = document.getElementById('geofence-map')
      if (!el) return

      const center = { lat, lng }
      const g = this.user.geofences[this.mapGeofenceIdx] || {}
      const radius = Number(g.radius) || 100

      if (!this.map) {
        this.map = new window.google.maps.Map(el, { center, zoom: 15 })
        this.map.addListener('click', e => {
          const newLat = e.latLng.lat()
          const newLng = e.latLng.lng()
          this.mapMarker.setPosition({ lat: newLat, lng: newLng })
          this.updateGeofenceLatLng(this.mapGeofenceIdx, newLat, newLng)
          if (this.mapCircle) {
            this.mapCircle.setCenter({ lat: newLat, lng: newLng })
          }
        })
      } else {
        this.map.setCenter(center)
      }

      if (!this.mapMarker) {
        this.mapMarker = new window.google.maps.Marker({
          map: this.map,
          position: center,
          draggable: true,
        })

        this.mapMarker.addListener('dragend', e => {
          this.updateGeofenceLatLng(this.mapGeofenceIdx, e.latLng.lat(), e.latLng.lng())
          if (this.mapCircle) {
            this.mapCircle.setCenter({ lat: e.latLng.lat(), lng: e.latLng.lng() })
          }
        })
      } else {
        this.mapMarker.setPosition(center)
      }

      if (!this.mapCircle) {
        this.mapCircle = new window.google.maps.Circle({
          map: this.map,
          center,
          radius,
          fillColor: '#4285F4',
          fillOpacity: 0.15,
          strokeColor: '#4285F4',
          strokeOpacity: 0.7,
          strokeWeight: 2,
          clickable: false,
        })
      } else {
        this.mapCircle.setCenter(center)
        this.mapCircle.setRadius(radius)
      }

      this.$nextTick(() => {
        window.google.maps.event.trigger(this.map, 'resize')
        this.map.setCenter(this.mapMarker.getPosition())
      })
    },
    async openMapModal(idx) {
      this.mapGeofenceIdx = idx
      const geofence = this.user.geofences[idx]
      if ((!geofence.latitude || !geofence.longitude) && geofence.address && window.google?.maps?.Geocoder) {
        this.loadingStates.map = true
        const geocoder = new window.google.maps.Geocoder()
        geocoder.geocode({ address: geofence.address }, (results, status) => {
          if (status === 'OK' && results && results[0]) {
            const loc = results[0].geometry.location
            geofence.latitude = loc.lat()
            geofence.longitude = loc.lng()
          }
          this.showMapModal = true
          this.loadingStates.map = false
        })
      } else {
        this.showMapModal = true
      }
    },
    onMapShown() {
      this.initMapForGeofence(this.mapGeofenceIdx)
      this.$nextTick(() => {
        if (this.map && this.mapMarker && this.mapCircle) {
          window.google.maps.event.trigger(this.map, 'resize')
          const bounds = this.mapCircle.getBounds()
          if (bounds) {
            this.map.fitBounds(bounds)
          } else {
            this.map.setCenter(this.mapMarker.getPosition())
          }
        }
      })
    },
    onMapHidden() {
      this.map = null
      this.mapMarker = null
      this.mapCircle = null
      this.loadingStates.map = false
    },
    updateGeofenceLatLng(idx, lat, lng) {
      const g = this.user.geofences[idx]
      g.latitude = lat
      g.longitude = lng
      this.reverseGeocodeAddress(idx, lat, lng)
    },
    reverseGeocodeAddress(idx, lat, lng) {
      if (!window.google?.maps?.Geocoder) return
      const geocoder = new window.google.maps.Geocoder()
      geocoder.geocode({ location: { lat, lng } }, (results, status) => {
        if (status === 'OK' && results && results[0]) {
          this.user.geofences[idx].address = results[0].formatted_address
        }
      })
    },
    async initGooglePlaces() {
      try {
        await this.loadGooglePlacesAPI()
        if (window.google?.maps?.places) {
          this.placesService = new window.google.maps.places.AutocompleteService()
        }
      } catch (error) {
        console.error('Erro ao inicializar Google Places:', error)
      }
    },

    handleGeofenceAddressInput(idx) {
      this.filters.geofenceIdx = idx
      if (this.searchTimeout) clearTimeout(this.searchTimeout)
      const { address } = this.user.geofences[idx]
      if (!address || address.length < 3) {
        this.addressSuggestions = []
        this.showAddressDropdown = false
        return
      }
      if (!this.placesService) {
        this.initGooglePlaces().then(() => {
          this.searchAddresses(address)
        })
      } else {
        this.searchTimeout = setTimeout(() => this.searchAddresses(address), 300)
      }
    },

    handleGeofenceAddressFocus(idx) {
      this.filters.geofenceIdx = idx
      this.showAddressDropdown = this.addressSuggestions.length > 0
    },

    handleGeofenceAddressBlur(idx) {
      setTimeout(() => {
        this.showAddressDropdown = false
        this.selectedSuggestionIndex = -1
        this.filters.geofenceIdx = null
      }, 200)
    },

    handleGeofenceAddressKeydown(event, idx) {
      if (!this.showAddressDropdown || this.addressSuggestions.length === 0) return
      const actions = {
        ArrowDown: () => {
          event.preventDefault()
          this.selectedSuggestionIndex = Math.min(
            this.selectedSuggestionIndex + 1,
            this.addressSuggestions.length - 1,
          )
        },
        ArrowUp: () => {
          event.preventDefault()
          this.selectedSuggestionIndex = Math.max(this.selectedSuggestionIndex - 1, -1)
        },
        Enter: () => {
          event.preventDefault()
          if (this.selectedSuggestionIndex >= 0) {
            this.selectGeofenceAddressSuggestion(this.addressSuggestions[this.selectedSuggestionIndex], idx)
          }
        },
        Escape: () => {
          this.showAddressDropdown = false
          this.selectedSuggestionIndex = -1
        },
      }
      actions[event.key]?.()
    },

    clearGeofenceAddress(idx) {
      this.user.geofences[idx].address = ''
      this.addressSuggestions = []
      this.showAddressDropdown = false
    },

    selectGeofenceAddressSuggestion(suggestion, idx) {
      this.user.geofences[idx].address = suggestion.description
      this.showAddressDropdown = false
      this.selectedSuggestionIndex = -1
      this.addressSuggestions = []

      if (window.google?.maps?.Geocoder) {
        const geocoder = new window.google.maps.Geocoder()
        geocoder.geocode({ address: suggestion.description }, (results, status) => {
          if (status === 'OK' && results && results[0]) {
            const lat = results[0].geometry.location.lat()
            const lng = results[0].geometry.location.lng()
            this.user.geofences[idx].latitude = lat
            this.user.geofences[idx].longitude = lng
            if (results[0].geometry.bounds) {
              const ne = results[0].geometry.bounds.getNorthEast()
              const sw = results[0].geometry.bounds.getSouthWest()
              const R = 6371000
              const dLat = (ne.lat() - sw.lat()) * Math.PI / 180
              const dLng = (ne.lng() - sw.lng()) * Math.PI / 180
              const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(sw.lat() * Math.PI / 180) * Math.cos(ne.lat() * Math.PI / 180) * Math.sin(dLng / 2) * Math.sin(dLng / 2)
              const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
              const distance = R * c
              this.user.geofences[idx].radius = Math.round(distance / 2)
            } else if (!this.user.geofences[idx].radius) {
              this.user.geofences[idx].radius = 100
            }
          }
        })
      } else if (!this.user.geofences[idx].radius) {
        this.user.geofences[idx].radius = 100
      }
    },

    handleAddressInput() {
      this.addressCoordinates = null
      this.distanceResults = []

      if (this.searchTimeout) clearTimeout(this.searchTimeout)

      if (this.filters.address.length < 3) {
        this.addressSuggestions = []
        this.showAddressDropdown = false
        return
      }

      this.searchTimeout = setTimeout(() => this.searchAddresses(), 300)
    },

    handleAddressFocus() {
      this.showAddressDropdown = this.addressSuggestions.length > 0
    },

    handleAddressBlur() {
      setTimeout(() => {
        this.showAddressDropdown = false
        this.selectedSuggestionIndex = -1
      }, 200)
    },

    searchAddresses(address) {
      if (!this.placesService || !address || address.length < 3) return
      const request = {
        input: address,
        componentRestrictions: { country: 'br' },
        types: ['address'],
      }
      this.placesService.getPlacePredictions(request, (predictions, status) => {
        const isOk = status === window.google.maps.places.PlacesServiceStatus.OK
        this.addressSuggestions = isOk && predictions
          ? predictions.map(prediction => ({
            place_id: prediction.place_id,
            main_text: prediction.structured_formatting.main_text,
            secondary_text: prediction.structured_formatting.secondary_text,
            description: prediction.description,
          }))
          : []
        this.showAddressDropdown = isOk && predictions
      })
    },

    highlightMatch(text, search) {
      if (!search) return text
      const regex = new RegExp(`(${search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi')
      return text.replace(regex, '<strong class="text-primary">$1</strong>')
    },

    clearAddress() {
      Object.assign(this.filters, { address: '', radius: null })
      Object.assign(this, {
        addressCoordinates: null,
        distanceResults: [],
        addressSuggestions: [],
        showAddressDropdown: false,
      })
    },
    handleAddressKeydown(event) {
      if (!this.showAddressDropdown || this.addressSuggestions.length === 0) return

      const actions = {
        ArrowDown: () => {
          event.preventDefault()
          this.selectedSuggestionIndex = Math.min(
            this.selectedSuggestionIndex + 1,
            this.addressSuggestions.length - 1,
          )
        },
        ArrowUp: () => {
          event.preventDefault()
          this.selectedSuggestionIndex = Math.max(this.selectedSuggestionIndex - 1, -1)
        },
        Enter: () => {
          event.preventDefault()
          if (this.selectedSuggestionIndex >= 0) {
            this.selectAddressSuggestion(this.addressSuggestions[this.selectedSuggestionIndex])
          }
        },
        Escape: () => {
          this.showAddressDropdown = false
          this.selectedSuggestionIndex = -1
        },
      }

      actions[event.key]?.()
    },

    async searchAddresses() {
      if (!this.placesService || !this.filters.address || this.filters.address.length < 3) return

      const request = {
        input: this.filters.address,
        componentRestrictions: { country: 'br' },
        types: ['address'],
      }

      this.placesService.getPlacePredictions(request, (predictions, status) => {
        const isOk = status === window.google.maps.places.PlacesServiceStatus.OK

        this.addressSuggestions = isOk && predictions
          ? predictions.map(prediction => ({
            place_id: prediction.place_id,
            main_text: prediction.structured_formatting.main_text,
            secondary_text: prediction.structured_formatting.secondary_text,
            description: prediction.description,
          }))
          : []

        this.showAddressDropdown = isOk && predictions
      })
    },

    async selectAddressSuggestion(suggestion) {
      this.filters.address = suggestion.description
      this.showAddressDropdown = false
      this.selectedSuggestionIndex = -1
      this.addressSuggestions = []
    },
    getOptionKey(option) {
      if (!option) return Math.random().toString(36).slice(2)
      if (typeof option === 'object') {
        return option.id || option.value || option.key || option.name || option.title || JSON.stringify(option)
      }
      return String(option)
    },
    validarFormulario() {
      if (!isValidEmail(this.user.email)) {
        this.$message('Erro', 'Informe um e-mail válido.', 'error')
        return false
      }

      if (!isValidCpf(this.user.cpf)) {
        this.$message('Erro', 'Informe um CPF válido.', 'error')
        return false
      }

      return true
    },

    requestCpfEdit() {
      if (this.cpfEditable) return;
      this.showCpfConfirmModal = true;
    },
    confirmCpfEdit() {
      this.cpfEditable = true;
      this.showCpfConfirmModal = false;
      this.$nextTick(() => {
        document.getElementById('cpf')?.focus();
      });
    },

    save: function () {
      const self = this;

      if (self.user.id) return self.edit()

      if (!self.validarFormulario()) return

      const api = `${this.$store.state.api}users`

      const fd = self.makeFormData()

      axios
        .post(api, fd)
        .then(response => {
          self.$message('Sucesso', 'Usuário cadastrado com sucesso', 'success')
          this.$router.push('/users')
        })
        .catch(error => {
          self.$message('Erro', apiErrorMessage(error), 'error')
        })
    },
    edit() {
      const self = this

      if (!self.validarFormulario()) return

      const api = `${self.$store.state.api}users/${self.user.id}`

      const fd = self.makeFormData()

      axios
        .post(api, fd)
        .then(response => {
          self.$message(
            'Sucesso',
            'Cadastro atualizado com sucesso',
            'success',
          )
          this.$router.push('/users')
        })
        .catch(error => {
          self.$message('Erro', apiErrorMessage(error), 'error')
        })
    },
    makeFormData() {
      const self = this

      const fd = new FormData()

      const photoInput = document.getElementById('photo')
      const photo = photoInput && photoInput.files ? photoInput.files[0] : null
      if (photo) {
        fd.append('photo', photo)
      }

      fd.append('name', self.user.name)
      fd.append('email', self.user.email)
      fd.append('remote_check', self.user.remote_check)
      fd.append(
        'department_id',
        self.user.department_id ? self.user.department_id : '',
      )
      fd.append('company_id', self.user.company_id ? self.user.company_id : '')
      fd.append('role_id', self.user.role_id ? self.user.role_id : '')
      fd.append(
        'admission_date',
        self.user.admission_date ? self.user.admission_date : '',
      )
      fd.append(
        'demission_date',
        self.user.demission_date ? self.user.demission_date : '',
      )
      fd.append('is_admin', self.user.is_admin ? self.user.is_admin : '')

      fd.append('photo_verified', self.user.photo_verified ? 1 : 0)
      fd.append('quick_access', self.user.quick_access !== null && self.user.quick_access !== undefined ? self.user.quick_access : '')

      const transportRaw = (self.user.transport_value || '0')
        .toString()
        .replace(/\./g, '')
        .replace(',', '.')
      fd.append('transport_value', transportRaw)
      fd.append('cpf', self.user.cpf)
      fd.append('ctps', self.user.ctps)
      fd.append('pis_pasep', self.user.pis_pasep)
      fd.append('active_date', self.user.active_date)
      fd.append('address', self.user.address ? self.user.address : '')

      const primaryAlocationId = Array.isArray(self.alocationsSelected) && self.alocationsSelected.length
        ? self.alocationsSelected[0]
        : (self.user.alocation_id || '')
      fd.append('alocation_id', primaryAlocationId || '')

      if (Array.isArray(self.alocationsSelected)) {
        self.alocationsSelected.forEach(alocationId => {
          fd.append('alocations[]', alocationId)
        })
      }

      if (Array.isArray(self.worktimesSelected)) {
        self.worktimesSelected.forEach(worktimeId => {
          if (worktimeId) {
            fd.append('worktimes[]', worktimeId)
          }
        })
      }

      if (Array.isArray(self.requirementsSelected)) {
        self.requirementsSelected.forEach(requirementId => {
          fd.append('requirements[]', requirementId)
        })
      }

      fd.append('geofence_enabled', self.user.geofence_enabled ? 1 : 0)
      if (Array.isArray(self.user.geofences)) {
        fd.append('geofences', JSON.stringify(self.user.geofences))
      }

      if (self.user.id) {
        fd.append('id', self.user.id)
        fd.append('active_date', self.user.active_date)
        fd.append('_method', 'PUT')
        if (self.user.password) {
          fd.append('password', self.user.password)
        }
      } else {
        fd.append('password', self.user.password || '')
      }

      return fd
    },

    getUser(id) {
      const self = this
      const api = `${self.$store.state.api}users/${id}?with[]=worktimes&with[]=geofences&with[]=alocations&with[]=requirements`

      axios
        .get(api)
        .then(response => {
          self.user = response.data.data[0]

          self.user.address = self.user.address || ''
          self.user.latitude = (self.user.latitude !== null && self.user.latitude !== undefined) ? parseFloat(self.user.latitude) : null
          self.user.longitude = (self.user.longitude !== null && self.user.longitude !== undefined) ? parseFloat(self.user.longitude) : null

          self.alocationsSelected = (self.user.alocations || []).map(alocation => alocation.id)
          self.requirementsSelected = [...new Set((self.user.requirements || []).map(r => r.id))]

          self.getUsersWorktime(self.user.id)

          if (self.user.geofences && Array.isArray(self.user.geofences)) {
            self.user.geofences = self.user.geofences.map(geofence => ({
              id: geofence.id || null,
              address: geofence.address || geofence.address_text || '',
              radius: geofence.radius || 100,
            }))
          } else {
            self.user.geofences = []
          }
        })
        .catch(error => {
          self.errors = error.response.data
          self.$message('Erro', apiErrorMessage(error), 'error')
        })
    },
    getUsersWorktime(user_id) {
      const self = this
      const api = `${self.$store.state.api}users_worktimes?user_id=${user_id}`

      axios
        .get(api)
        .then(response => {
          const list = (response.data && response.data.data) ? response.data.data : []
          self.worktimesSelected = list
            .map(item => (item && item.worktime ? item.worktime.id : null))
            .filter(Boolean)
        })
        .catch(error => {
          self.$message('Erro', apiErrorMessage(error), 'error')
        })
    },

    getDepartments() {
      const self = this
      const api = `${self.$store.state.api}departments/`

      axios
        .get(api)
        .then(response => {
          self.departments = response.data.data
        })
        .catch(error => {
          self.errors = error.response.data
          self.$message(null, self.errors, 'error')
        })
    },
    getCompany() {
      const self = this
      const api = `${self.$store.state.api}companies/`

      axios
        .get(api)
        .then(response => {
          self.companies = response.data.data
        })
        .catch(error => {
          self.errors = error.response.data
          self.$message(null, self.errors, 'error')
        })
    },
    getAlocation() {
      const self = this
      const api = `${self.$store.state.api}alocations/`

      axios
        .get(api)
        .then(response => {
          const arr = (response.data && response.data.data) ? response.data.data : []
          self.alocations = arr.filter(Boolean)
        })
        .catch(error => {
          self.errors = error.response.data
          self.$message(null, self.errors, 'error')
        })
    },
    getWorktimes() {
      const self = this
      const api = `${self.$store.state.api}worktimes/`

      axios
        .get(api)
        .then(response => {
          const arr = (response.data && response.data.data) ? response.data.data : []
          self.worktimes = arr.filter(Boolean)
        })
        .catch(error => {
          self.errors = error.response.data
          self.$message(null, self.errors, 'error')
        })
    },
    getRequirements() {
      const self = this
      const api = `${self.$store.state.api}requirements/`
      axios
        .get(api)
        .then(response => {
          self.requirements = (response.data && response.data.data) ? response.data.data : []
        })
        .catch(error => {
          self.$message('Erro', apiErrorMessage(error), 'error')
        })
    },
    getRoles() {
      const self = this
      const api = `${self.$store.state.api}roles/`

      axios
        .get(api)
        .then(response => {
          self.roles = response.data.data
        })
        .catch(error => {
          self.errors = error.response.data
          self.$message(null, self.errors, 'error')
        })
    },
    loadGooglePlacesAPI() {
      return new Promise((resolve, reject) => {
        if (window.google?.maps?.places) {
          resolve()
          return
        }
        if (document.querySelector('script[src*="maps.googleapis.com"]')) {
          const checkLoaded = setInterval(() => {
            if (window.google?.maps?.places) {
              clearInterval(checkLoaded)
              resolve()
            }
          }, 100)
          return
        }
        const script = document.createElement('script')
        script.src = `https://maps.googleapis.com/maps/api/js?key=${this.googleApiKey}&libraries=places&callback=initGoogleMaps`
        script.async = true
        script.defer = true
        window.initGoogleMaps = () => {
          delete window.initGoogleMaps
          resolve()
        }
        script.onerror = error => {
          reject(new Error('Falha ao carregar Google Maps API'))
        }
        document.head.appendChild(script)
      })
    },
  },
  mounted: function () {
    const self = this;
    self.initGooglePlaces();
    self.getDepartments();
    self.getRoles();

    let id = self.$route.params.id;
    if (id) {
      self.cpfEditable = false;
      self.getUser(id);
    }

    self.getDepartments();
    self.getAlocation();
    self.getRoles();
    self.getWorktimes();
    self.getCompany();
    self.getRequirements();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.custom-control-input:checked ~ .custom-control-label::before {
  background-color: #28a745 !important;
  border-color: #28a745 !important;
}

.custom-control-input:checked ~ .custom-control-label {
  color: #28a745;
}

.custom-control-label .fa {
  margin-right: 6px;
}

.badge-success .fa {
  margin-right: 6px;
}

custom-address-input {
  position: relative;
  width: 100%;
}

.address-input-container {
  position: relative;
  display: flex;
  align-items: center;
  border: 1px solid #ced4da;
  border-radius: 6px;
  background-color: #fff;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.address-input-container:focus-within {
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.address-icon {
  position: absolute;
  left: 12px;
  color: #6c757d;
  font-size: 16px;
  z-index: 2;
}

.address-input {
  flex: 1;
  border: none;
  outline: none;
  padding: 12px 16px 12px 40px;
  font-size: 14px;
  border-radius: 6px;
  background: transparent;
}

.address-input::placeholder {
  color: #adb5bd;
}

.clear-address-btn {
  position: absolute;
  right: 40px;
  background: none;
  border: none;
  color: #6c757d;
  padding: 8px;
  cursor: pointer;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  z-index: 2;
}

.clear-address-btn:hover {
  background-color: #f8f9fa;
  color: #dc3545;
}

.address-spinner {
  position: absolute;
  right: 12px;
  color: #007bff;
  z-index: 2;
}

.address-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  z-index: 9999;
  max-height: 300px;
  overflow-y: auto;
  margin-top: 4px;
}

.address-option {
  padding: 12px 16px;
  cursor: pointer;
  border-bottom: 1px solid #f8f9fa;
  transition: background-color 0.2s ease;
}

.address-option:last-child {
  border-bottom: none;
}

.address-option:hover,
.address-option.active {
  background-color: #f8f9fa;
}

.address-main {
  display: flex;
  align-items: center;
  font-weight: 500;
  color: #212529;
  margin-bottom: 4px;
}

.address-secondary {
  font-size: 13px;
  color: #6c757d;
  margin-left: 24px;
}
</style>
